import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['navItem']
  initialize() {
    /*global GIT_SHA*/
    /*eslint no-undef: "error"*/
    console.log('GIT_SHA', GIT_SHA)
  }
  connect() {}
  mainLinkHandler(e) {
    this.navItemTargets
      .filter((elem) => elem.classList.contains('show-sub-menu'))
      .map((elem) => elem.classList.remove('show-sub-menu'))
    document.body.classList.add('show-menu')
    e.target.closest('li')?.classList.add('show-sub-menu')
  }
  closeHandler() {
    this.navItemTargets
      .filter((elem) => elem.classList.contains('show-sub-menu'))
      .map((elem) => elem.classList.remove('show-sub-menu'))
    document.body.classList.remove('show-menu')
  }
}
